import { BrowserCacheLocation, Configuration, LogLevel } from "@azure/msal-browser";

export const environment = {
  production: false,
  baseUrl: null,
  loginUrl: '/login',
  roles: ['RadaUser'],
  showMyPlaylistRole: "RadaShowMyPlaylist"
};

const isIE = window.navigator.userAgent.indexOf("MSIE ") > -1 || window.navigator.userAgent.indexOf("Trident/") > -1;

//msal Azure
export const msalConfig: Configuration = {
  auth: {
    clientId: '10a13159-e90b-46c1-a7db-43c1ec63a8cc',
    authority: 'https://login.microsoftonline.com/6dc8f987-c886-4792-acef-76455cc290b9',
    redirectUri: '/'
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage, // Configures cache location. "sessionStorage" is more secure, but "localStorage" gives you SSO between tabs.
    storeAuthStateInCookie: isIE, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback(logLevel: LogLevel, message: string) {
        console.log(message + "[" + logLevel + "]");
      },
      logLevel: LogLevel.Error,
      piiLoggingEnabled: false
    }
  }
}

export const tenantId = '6dc8f987-c886-4792-acef-76455cc290b9';

export const loginRequest = {
  scopes: ["api://10a13159-e90b-46c1-a7db-43c1ec63a8cc/RadaLogin-Dev"]
};
